(function () {
  if (window.__rsSavedProductGridReady) return;
  window.__rsSavedProductGridReady = true;

  var storageKey = 'realstil_saved_products_v1';

  var copy = {
    de: { save: 'Produkt speichern', saved: 'Produkt gespeichert' },
    en: { save: 'Save product', saved: 'Product saved' },
    fr: { save: 'Enregistrer le produit', saved: 'Produit enregistré' },
    nl: { save: 'Product opslaan', saved: 'Product opgeslagen' },
    tr: { save: 'Ürünü kaydet', saved: 'Ürün kaydedildi' }
  };

  function language() {
    var value = String(document.documentElement.lang || navigator.language || 'de').toLowerCase().slice(0, 2);
    return copy[value] ? value : 'de';
  }

  function t(key) {
    return copy[language()][key];
  }

  function injectVisualPolish() {
    if (document.getElementById('rs-wishlist-visual-polish')) return;

    var style = document.createElement('style');
    style.id = 'rs-wishlist-visual-polish';
    style.textContent = [
      '.logo-area__right__inner .wishlist-hero-header-icon{display:none!important}',
      '.logo-area__right__inner .rs-saved-header-link{display:inline-flex!important;align-items:center!important;justify-content:center!important;flex:0 0 24px!important;width:24px!important;min-width:24px!important;height:24px!important;margin:0!important;padding:0!important;line-height:0!important}',
      '.logo-area__right__inner .rs-saved-header-link .cart-link__icon{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:24px!important;height:24px!important;margin:0!important;padding:0!important}',
      '.logo-area__right__inner .rs-saved-header-link + .cart-link{margin-left:14px!important}',
      '.rs-saved-header-link .cart-link__icon::before,.rs-save-product::before,.rs-product-card-save::before{content:""!important;display:block!important;width:24px!important;height:24px!important;flex:0 0 24px!important;background-color:currentColor!important;-webkit-mask-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M7 2.75h10A1.25 1.25 0 0 1 18.25 4v17L12 17.1 5.75 21V4A1.25 1.25 0 0 1 7 2.75Z%27 fill=%27none%27 stroke=%27black%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E")!important;-webkit-mask-repeat:no-repeat!important;-webkit-mask-position:center!important;-webkit-mask-size:24px 24px!important;mask-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M7 2.75h10A1.25 1.25 0 0 1 18.25 4v17L12 17.1 5.75 21V4A1.25 1.25 0 0 1 7 2.75Z%27 fill=%27none%27 stroke=%27black%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E")!important;mask-repeat:no-repeat!important;mask-position:center!important;mask-size:24px 24px!important}',
      '.rs-save-product.is-saved::before,.rs-product-card-save.is-saved::before{-webkit-mask-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M7 2.75h10A1.25 1.25 0 0 1 18.25 4v17L12 17.1 5.75 21V4A1.25 1.25 0 0 1 7 2.75Z%27 fill=%27black%27/%3E%3C/svg%3E")!important;mask-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M7 2.75h10A1.25 1.25 0 0 1 18.25 4v17L12 17.1 5.75 21V4A1.25 1.25 0 0 1 7 2.75Z%27 fill=%27black%27/%3E%3C/svg%3E")!important}',
      '.rs-product-card-save{border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;color:#111!important}',
      '.rs-product-card-save::before{width:21px!important;height:21px!important;flex:0 0 21px!important;-webkit-mask-size:21px 21px!important;mask-size:21px 21px!important}',
      '.rs-product-card-save:hover,.rs-product-card-save:active{border:0!important;background:transparent!important;box-shadow:none!important}',
      '@media(max-width:767.98px){.logo-area__right__inner .rs-saved-header-link + .cart-link{margin-left:12px!important}.rs-product-card-save{background:transparent!important;border:0!important;box-shadow:none!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function readSaved() {
    try {
      var value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function isSaved(id) {
    return readSaved().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function cleanText(node) {
    if (!node) return '';
    return String(node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function getBlocks(scope) {
    var root = scope || document;
    var blocks = [];

    if (root.nodeType === 1 && root.matches && root.matches('product-block.product-block')) {
      blocks.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('product-block.product-block').forEach(function (block) {
        blocks.push(block);
      });
    }

    return blocks;
  }

  function productHandle(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/i);
    return match ? match[1] : '';
  }

  function imageUrl(image) {
    if (!image) return '';
    return image.currentSrc || image.src || image.getAttribute('data-src') || image.getAttribute('data-srcset') || '';
  }

  function syncButton(button) {
    var active = isSaved(button.dataset.rsSaveProduct);
    var saveLabel = button.dataset.rsAriaSave || t('save');
    var savedLabel = button.dataset.rsAriaSaved || t('saved');
    var status = button.querySelector('[data-rs-save-status]');

    button.classList.toggle('is-saved', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? savedLabel : saveLabel);
    if (status) status.textContent = active ? savedLabel : saveLabel;
  }

  function addButton(block) {
    var imageContainer = block.querySelector('.image-cont');
    if (!imageContainer || imageContainer.querySelector('.rs-product-card-save')) return;

    var id = block.getAttribute('data-product-id');
    if (!id) return;

    var link = block.querySelector('a.product-link[href*="/products/"]') || block.querySelector('a[href*="/products/"]');
    if (!link) return;

    var url = link.getAttribute('href') || '';
    var titleNode = block.querySelector('.product-block__title, .product-block__title-link');
    var priceNode = block.querySelector('.product-price--block, .product-price, .price');
    var image = imageContainer.querySelector('img');
    var title = cleanText(titleNode) || link.getAttribute('aria-label') || '';
    var price = cleanText(priceNode);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'rs-product-card-save';
    button.setAttribute('data-rs-save-product', id);
    button.setAttribute('data-rs-product-handle', productHandle(url));
    button.setAttribute('data-rs-product-url', url);
    button.setAttribute('data-rs-product-title', title);
    button.setAttribute('data-rs-product-image', imageUrl(image));
    button.setAttribute('data-rs-product-price', price);
    button.setAttribute('data-rs-aria-save', t('save'));
    button.setAttribute('data-rs-aria-saved', t('saved'));
    button.setAttribute('aria-label', t('save'));
    button.setAttribute('aria-pressed', 'false');

    var status = document.createElement('span');
    status.className = 'visually-hidden';
    status.setAttribute('data-rs-save-status', '');
    status.setAttribute('aria-live', 'polite');
    status.textContent = t('save');
    button.appendChild(status);

    imageContainer.appendChild(button);
    syncButton(button);
  }

  function initialise(scope) {
    getBlocks(scope).forEach(addButton);
  }

  function syncAllCardButtons() {
    document.querySelectorAll('.rs-product-card-save[data-rs-save-product]').forEach(syncButton);
  }

  function observeProductGrid() {
    if (!window.MutationObserver || !document.body || window.__rsSavedProductGridObserver) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (!node || node.nodeType !== 1) return;
          if (
            (node.matches && node.matches('product-block.product-block')) ||
            (node.querySelector && node.querySelector('product-block.product-block'))
          ) {
            initialise(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.__rsSavedProductGridObserver = observer;
  }

  function start() {
    injectVisualPolish();
    initialise(document);
    observeProductGrid();
  }

  document.addEventListener('shopify:section:load', function (event) {
    injectVisualPolish();
    initialise(event.target);
  });

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) syncAllCardButtons();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
